export default __webpack_public_path__ + "static/media/patient2.90e91dde.png";